import { render } from "./PriceListBulkPropertyDialog.vue?vue&type=template&id=99d9e242"
import script from "./PriceListBulkPropertyDialog.vue?vue&type=script&lang=js"
export * from "./PriceListBulkPropertyDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__